import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Educator({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-6 -1.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M27.3333337 20.9363685L13.9996815 13.666667.666667 20.9363685v14.3969652h26.6666667zM13.666667 7.37179521V1.666667l9.4230769 5.70512821zM13.3333337 14.166667v-12.5" />
        <path d="M10.666667 35.666667h6.6666667v-10H10.666667z" />
      </g>
    </svg>
  )
}

Educator.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
